module.exports = __webpack_public_path__ + "static/media/37.fe83f856.jpg";